module.exports = __webpack_public_path__ + "static/media/negative.03f4c2dd.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/audio/notifications/negative.ogg
// module id = 2781
// module chunks = 0